import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import { useParams } from "react-router-dom";
import Spinner from "../../components/Reuseable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
import generateInvoiceHTML from "../Print/invoice";
import { CompanyLogo } from "../../images";
const SalesLedgerDetailsComponent = loadable(
  () => import("../../components/SalesLedger/SalesLedgerDetails")
);
type Props = {};

const SalesLedgerDetails = (props: Props) => {
  const { id } = useParams();
  let ComLogo: any;
  async function loadLogo() {
    const response = await fetch(CompanyLogo);
    const blob = await response.blob();
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  loadLogo().then((base64Logo) => {
    ComLogo = base64Logo
  });
  const { data: salesDetailsData, isPending: salesDetailsLoading } = useGetHook(
    {
      queryKey: [`invoice${id}`],
      url: `${APIS.INVOICE}${id}/`,
      params: {},
    }
  );
  const handlePrintInvoice = async (type: any) => {

    async function getBase64(url: string) {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }

    try {
      const printWindow = window.open('', '_blank', 'width=800,height=600');
      const base64Logo = await getBase64(CompanyLogo);
      const image = `<img src="${base64Logo}" alt="Logo" style="width: 90%; height: 90%; object-fit: contain;" />`;

      if (!printWindow) return;

      printWindow.document.open();
      printWindow.document.write(generateInvoiceHTML(salesDetailsData, type, image));
      printWindow.document.close();

      // Wait for the image(s) to load before printing
      const imgs: any = printWindow.document.images;
      if (imgs.length === 0) {
        printWindow.print();
        printWindow.close();
        return;
      }
      let loaded = 0;
      for (let img of imgs) {
        img.onload = () => {
          loaded++;
          if (loaded === imgs.length) {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }
        };

        img.onerror = () => {
          loaded++;
          if (loaded === imgs.length) {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }
        };
      }

    } catch (err) {
      console.error("Error while fetching invoice data:", err);
    }
  };

  const { isPostLoading: isEmailLoading, mutateAsync: emailMutateAsync, postData: emailData } = usePostHook({ queryKey: ["email-send"], navigateURL: null });

  const handleSendEmail = async () => {
    if (id) {
      const url = `${APIS.INVOICE}${id}/send-email/?is_sales_ledger=True`;
      try {
        const res = await emailMutateAsync({ url })
      } catch (e) {
        console.log(e, "Error Sending Email")
      }

    }
  };
  return (
    <>
      {salesDetailsLoading ? (
        <Spinner />
      ) : (
        <SalesLedgerDetailsComponent
          salesDetailsData={salesDetailsData}
          handleSendEmail={handleSendEmail}
          handlePrintInvoice={handlePrintInvoice} />
      )}
    </>
  );
};

export default SalesLedgerDetails;
